import { render, staticRenderFns } from "./return-modal.vue?vue&type=template&id=a9218a4c&"
import script from "./return-modal.vue?vue&type=script&lang=js&"
export * from "./return-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports